import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';

const touchend = 'touchend',
  manual = 'manual',
  timer = 'timer';

function getOverlayChildComponent(placement, popoverChildComponent) {
  return (
    <Popover id={`popover-positioned-${placement}`}>
      {popoverChildComponent}
    </Popover>
  );
}

/**
 * @todo
 * Considerably more refactoring is possible to make this a better Component API
 */
class ToolTipComponent extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onExit = this.onExit.bind(this);
    this.hideTip = this.hideTip.bind(this);
    this.doShow = true;
  }

  onEnter() {
    this.doShow = false;
    window.addEventListener(touchend, this.hideTip);
  }

  onExit() {
    this.doShow = true;
    window.removeEventListener(touchend, this.hideTip);
  }

  getOverlayTrigger(
    container,
    trigger,
    placement,
    childComponent,
    popoverChildComponent
  ) {
    return (
      <OverlayTrigger
        ref="triggerPoint"
        container={container}
        trigger={trigger}
        placement={placement}
        overlay={getOverlayChildComponent(placement, popoverChildComponent)}
        onClick={this.handleClick}
        onEnter={this.onEnter}
        onExit={this.onExit}
        rootClose
      >
        {childComponent}
      </OverlayTrigger>
    );
  }

  handleClick(e) {
    if (this.props.trigger === timer) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      const trigger = this.refs.triggerPoint;

      if (this.props.doShow) {
        trigger.show();
        this.timer = setTimeout(() => {
          trigger.hide();
        }, 2500);
      } else {
        trigger.hide();
      }
    } else if (this.props.trigger === manual) {
      e.stopPropagation();
      const trigger = this.refs.triggerPoint;
      if (this.doShow) {
        trigger.show();
      } else {
        trigger.hide();
      }
    }
  }

  hideTip() {
    this.refs.triggerPoint.hide();
  }

  render() {
    let scope;
    const triggerName =
      this.props.trigger === timer ? manual : this.props.trigger;

    if (this.props.hasSvg) {
      scope = this.props.scope;
    } else {
      scope = this;
    }

    return (
      <div className={`pos-r ${this.props.className}`}>
        {this.getOverlayTrigger(
          scope,
          triggerName,
          this.props.placement,
          this.props.childComponent,
          this.props.popoverChildComponent
        )}
      </div>
    );
  }
}

ToolTipComponent.defaultProps = {
  popoverChildComponent: <strong>Holy guacamole!</strong>,
  trigger: 'click',
  placement: 'left', // 'left' || 'right' || 'top' || 'bottom',
  childComponent: (
    <Button className="button button--jumbo">Left Tooltip</Button>
  ), //|| <a className="button button--link">Top Tooltip</a>,
  tooltipHeading: 'ToolTip',
  tooltipHeadingClass: 'title',
  sectionClass: 'text-center',
  subTitleClass: 'subtitle',
  subTitle: 'sub title',
  subTitleClassFlag: true,
  titleFlag: true,
  hasSvg: false,
  scope: this,
  className: '',
};

ToolTipComponent.propTypes = {
  trigger: PropTypes.string,
  placement: PropTypes.string,
  childComponent: PropTypes.object,
  popoverChildComponent: PropTypes.object,
  tooltipHeadingClass: PropTypes.string,
  tooltipHeading: PropTypes.string,
  sectionClass: PropTypes.string,
  subTitleClass: PropTypes.string,
  subTitle: PropTypes.string,
  subtitleClassFlag: PropTypes.bool,
  titleFlag: PropTypes.bool,
  hasSvg: PropTypes.bool,
  className: PropTypes.string,
};

export { ToolTipComponent };
